import {GET_SINGLE_HUB, HIDE_SINGLE_HUB} from  "../actions/types";

const initialState={
    hubData: [], 
    loading:true
} 

const getSingleHubReducer =(state=initialState,{type,payload})=>{
    switch(type){
        case GET_SINGLE_HUB : return{
            ...state,
            hubData : payload
        }
        case HIDE_SINGLE_HUB : return{
            ...state,
            loading:false
        }
        default: return state;  
    }
}
export default getSingleHubReducer